import React from "react";
import data from "../Data";
import Btn from "../../../ReUseAbleComp/Button.jsx";
import Header from "../../../ReUseAbleComp/Header.jsx";
import Search from "../../../ReUseAbleComp/SearchInput.jsx";

import { BsArrowRight, BsArrowLeft } from "react-icons/bs";

function LGEnglish({
  GeneralsearchTerm,
  setGeneralSearchTerm,
  GeneralsearchResults,
  GeneralUrduSearch,
  GeneralPashtoSearch,
  handleGeneralChange,
  searchTagUrdu,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>جنرل</h1>
        <Search
          handleChange={handleGeneralChange}
          searchTerm={GeneralsearchTerm}
          searchTagUrdu={searchTagUrdu}
          dir="rtl"
        />

        {GeneralUrduSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Utitle}
            id={item.RID}
            path={`/GeneralUrduDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
